<template>
  <main class="main mobile_main bg_gr" role="main" ref="main">
    <div class="phone">
      <div class="sect main_sevice_top">
        <div class="sevice_ani">
          <Lottie :options="options" @animCreated="handleAnimation" />
        </div>
        <div class="txt">
          <h2>휴대폰 견적을 받아보세요!</h2>
          <p>최저가 휴대폰 우리동네 매장에서 제안 받기</p>
        </div>
        <div class="btn_top">
          <button @click="goMobileCreate">바로 견적 요청하기</button>
        </div>
      </div>
      <MobileProducts
        ref="MobileProducts"
        :params="mobileProductParams"
        :filter="mobileFilter"
        :list="mobileProductList"
        :total="mobileProductTotal"
        @fetch="mobileProductFilter"
        @filter="openMobileFilter"
        @reset="resetMobileFilter"
        @more="mobileViewMore"
        @view="goMobileView"
        @searchKeyword="searchKeyword"
      />
      <!-- 퍼스 추천/관심 매장-->
      <MainShops ref="mainShops" @setShopVisitPage="setShopVisitPage" />
    </div>
    <MobileFilter
      ref="mobileFilter"
      :show="isMobileFilter"
      :filterSelTab="mobileFilterSelTab"
      @close="closeMobileFilter"
    />
  </main>
</template>
<script>
import Lottie from 'vue-lottie/src/lottie';
import * as animationData from '@/assets/front/animation/ani_home_phone.json';

import format from 'date-fns/format';

import * as util from '@common/lib/common/utils.js';

import MobileProducts from '@/front/customer/views/home/components/MobileProducts';

import MobileFilter from '@/common/components/modal/MobileFilter';

import MainShops from '@/front/customer/views/home/components/MainShops.vue';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  name: 'MobileMain',
  components: {
    Lottie,
    MobileProducts,
    MobileFilter,
    MainShops,
  },

  data() {
    return {
      options: { animationData: animationData.default },
      // animationSpeed: 1,
      isCompleted: false,

      isMobileFilter: false,
      mobileProductParams: {
        page: 1,
        size: 5,
        orderType: 'POPULARITY', // CREATED_AT_DESC: 최신 출시순,  PRICE_DESC : 높은 가격순,  PRICE_ASC : 낮은 가격순, POPULARITY : 인기순
        selBookmark: 'N', // 찜하기
        keyword: '', // 검색어
        wirelessCharge: 'OFF',
        samsungPay: 'OFF',
        applePay: 'OFF',
        waterproof: 'OFF',
        film: 'OFF',
      },
      mobileFilter: {
        manufacturer: ['ALL'],
        ram: ['ALL'],
        inMemory: ['ALL'],
        exMemory: ['ALL'],
        screen: ['ALL'],
        battery: ['ALL'],
      },
      mobileProductList: [],
      mobileProductTotal: 0,
      mobileFilterSelTab: '',
      isMobileBack: false,

      isVisitName: [
        'Search',
        'MyPage.Main',
        'InternetCommerce.Create',
        'InternetCommerce.List',
        'InternetCommerce.ItemView',
      ], // 뒤로 이동시 가능한 방문 페이지 정리
    };
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      // alert(from.name);
      await vm.fetch(from.name);
    });
  },
  async created() {
    util.nativeEnableBackKey();
    await this.getMobileProducts(); // 휴대폰 스펙 찾기
    this.isCompleted = true;
    await this.goScrollLocation(); // 위치 이동
    await util.nativeNotification();
  },
  async mounted() {},
  computed: {
    ...mobileMapGetters({
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
    }),
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_PRODUCTS,
      mobileTypes.UPDATE_MOBILE_VIEW_PRODUCT,
    ]),
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = localStorage.getItem('position_mobile_home');
        if (visit_page) {
          visit_page = JSON.parse(visit_page);

          this.scrollLocation = visit_page.scrollLocation;

          // 데이터 담고 삭제
          localStorage.removeItem('position_mobile_home');
        }
      }
    },
    async goScrollLocation() {
      setTimeout(() => {
        window.scrollTo(0, this.scrollLocation);
      }, 0.5);
      // });
    },
    setShopVisitPage(shopTab) {
      this.shopTab = shopTab;
    },
    ////////////////////////////////////////////////
    // 휴대폰 스펙찾기 관련 함수 시작
    async getMobileProducts() {
      if (!this.isMobileBack) {
        // 인터넷 필터 string으로 변환
        this.mobileProductParams.manufacturers = this.mobileFilter.manufacturer.join(
          ',',
        );
        this.mobileProductParams.rams = this.mobileFilter.ram.join(',');
        this.mobileProductParams.memoryEmbs = this.mobileFilter.inMemory.join(
          ',',
        );
        this.mobileProductParams.memoryExts = this.mobileFilter.exMemory.join(
          ',',
        );
        this.mobileProductParams.screens = this.mobileFilter.screen.join(',');
        this.mobileProductParams.batteries = this.mobileFilter.battery.join(
          ',',
        );
      }
      await this[mobileTypes.SELECT_MOBILE_PRODUCTS](
        this.mobileProductParams,
      ).then(res => {
        if (res.content) {
          this.mobileProductList = this.mobileProductList.concat(res.content);
        }
        this.mobileProductTotal = res.totalCount;
        console.log('res');
        console.log(res);
      });

      console.log('this.mobileProductList');
      console.log(this.mobileProductList);
      console.log('this.mobileProductParams');
      console.log(this.mobileProductParams);
    },
    mobileProductInit() {
      this.isMobileBack = false;
      this.mobileProductParams.page = 1;
      this.mobileProductParams.size = 5;
      this.mobileProductParams.keyword = this.$refs.MobileProducts.keyword.trim();
      this.mobileProductList = [];
    },
    async mobileProductFilter(type, val) {
      await this.mobileProductInit();
      this.mobileProductParams[type] = val;
      await this.getMobileProducts();
    },
    mobilePageSet() {
      if (
        this.mobileProductParams.size > 5 &&
        this.mobileProductParams.page == 1
      ) {
        this.mobileProductParams.page = this.mobileProductParams.size / 5;
        this.mobileProductParams.size = 5;
      }
    },
    mobileViewMore() {
      this.mobilePageSet();
      this.mobileProductParams.page++;
      this.getMobileProducts();
    },
    openMobileFilter(selTab) {
      this.isMobileFilter = true;
      this.mobileFilterSelTab = selTab;
      document.body.style.overflow = 'hidden';
    },
    closeMobileFilter(
      dataType,
      manufacturer,
      ram,
      inMemory,
      exMemory,
      screen,
      battery,
    ) {
      if (dataType) {
        this.mobileFilter.manufacturer = manufacturer;
        this.mobileFilter.ram = ram;
        this.mobileFilter.inMemory = inMemory;
        this.mobileFilter.exMemory = exMemory;
        this.mobileFilter.screen = screen;
        this.mobileFilter.battery = battery;
        this.mobileProductInit();
        this.getMobileProducts();
      }
      this.isMobileFilter = false;
      document.body.style.overflow = '';
    },
    goMobileView(item) {
      // 상품 조회 카운트 증가
      this.upMobileViewProductCnt(item);

      localStorage.setItem('mobileProductSelect', JSON.stringify(item));
      this.$router.push({
        name: 'Mobile.ItemView',
      });
    },
    upMobileViewProductCnt(item) {
      const params = {
        modelId: item.modelId,
      };
      this[mobileTypes.UPDATE_MOBILE_VIEW_PRODUCT](params);
    },
    async searchKeyword(keyword) {
      await this.mobileProductInit();
      this.mobileProductParams.keyword = encodeURIComponent(keyword);
      await this.getMobileProducts();
    },
    resetMobileFilter() {
      this.mobileProductParams.orderType = 'POPULARITY';
      this.mobileProductParams.selBookmark = 'N';
      this.mobileProductParams.keyword = '';
      this.mobileProductParams.wirelessCharge = 'OFF';
      this.mobileProductParams.samsungPay = 'OFF';
      this.mobileProductParams.applePay = 'OFF';
      this.mobileProductParams.waterproof = 'OFF';
      this.mobileProductParams.film = 'OFF';

      this.mobileFilter = {
        manufacturer: ['ALL'],
        ram: ['ALL'],
        inMemory: ['ALL'],
        exMemory: ['ALL'],
        screen: ['ALL'],
        battery: ['ALL'],
      };
      this.mobileProductInit();
      this.getMobileProducts();
    },
    goLink(link) {
      this.$router.push({ name: link });
    },
    async goMobileCreate() {
      this.goLink('Mobile.Create');
    },
  },
};
</script>
